module.exports = __webpack_public_path__ + "static/4-2e2ddb915791d677d7166e6fedc135a8.jpg";